import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ClientJS } from "clientjs";
import "./login.css";
import ToastMessage from "../ToastMessage/ToastMessage";
import {
  signIn,
  getCaptcha,
  captchaVerification,
  sendOtp,
  verifyOtp,
} from "../../utils/request"; // Import Api Functions
import loginCodes from "../../utils/loginCodes";
import OTPInput from "react-otp-input";

const temp_res_data = {
  url: "http://localhost:3001",
  jwt: "dasdasdSADASWEREWFW$@#FDS%@#RDSFC@#R@",
};

const Login = () => {
  // const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false); // State for toggling password visibility
  const [captchaCode, setCaptchaCode] = useState("1234");
  const [captchaId, setCaptchaId] = useState();
  const [captcha, setCaptcha] = useState(null);
  const [displayOtpModal, setDisplayOtpModal] = useState(false);
  const [timerCount, setTimerCount] = useState(0);
  const [showResendOTP, setShowResendOTP] = useState(false);
  const [displayNewPasswordModal, setDisplayNewPasswordModal] = useState(false);
  const [displayTempNewPasswordModal, setDisplayTempNewPasswordModal] = useState(false);
  const [userId, setUserId] = useState("");
  const [verifySpin, setVerifySpin] = useState(false);
  const [otp, setOtp] = useState("");

  const navigate = useNavigate(); // Hook to navigate to another route

  // Extract callback URL from URL query parameters
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const callbackUrl = queryParams.get("callbackUrl") || temp_res_data.url;
  const clientId = queryParams.get("clientId");

  const client = new ClientJS();
  /**
   * Get the client's fingerprint id
   */
  const fingerprint = client.getFingerprint();


  sessionStorage.setItem(
    "clientId",
    JSON.stringify(clientId)
  );

  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent default form submission

    // Reset states before each submit attempt
    setIsLoading(true);
    setError("");
    setSuccessMessage("");

    try {
      const captchaData = {
        captchaId,
        captcha,
      };

      // First, verify the CAPTCHA
      const captchaResponse = await captchaVerification(captchaData);
      console.log(captchaResponse); // Debug CAPTCHA response

      // Check if CAPTCHA verification was successful (e.g., code 20)
      if (captchaResponse.code !== 20) {
        throw new Error("Captcha verification failed. Please try again.");
      }

      // If CAPTCHA is successful, proceed with sign-in API
      const userSignInData = {
        email: email,
        password: password,
        browser_id: `${fingerprint}`,
        token: clientId,
      };

      console.log("Sending sign-in request:", userSignInData); // Debug sign-in data

      const signInResponse = await signIn(userSignInData);
      console.log("Sign-in response:", signInResponse); // Debug API response

      // Handle different sign-in response cases
      if (signInResponse?.code === loginCodes.OTP_SENT_TO_MAIL) {
        setDisplayOtpModal(true);
        startTimer(signInResponse?.resendOtpTime);
        setShowResendOTP(true);

        const otpVerificationData = {
          email: userSignInData.email,
          browser_id: userSignInData.browser_id,
          token: userSignInData.token,
          resendOtpTime: signInResponse?.resendOtpTime,
        };

        sessionStorage.setItem(
          "otpVerificationData",
          JSON.stringify(otpVerificationData)
        );
        navigate("/otp-verification");
      } else if (signInResponse?.user?.is_temporary) {
        setDisplayNewPasswordModal(true);
        setDisplayTempNewPasswordModal(true);
        setUserId(signInResponse?.user?.id);
        
        const otpVerificationData = {
          email: userSignInData.email,
          browser_id: userSignInData.browser_id,
          token: userSignInData.token,
          resendOtpTime: signInResponse?.resendOtpTime,
        };

        sessionStorage.setItem(
          "otpVerificationData",
          JSON.stringify(otpVerificationData)
        );
        navigate("/temp-password");
      } else if (signInResponse?.code === 20 && signInResponse?.accessToken) {
        const token = signInResponse.accessToken;
        document.cookie = `authToken=${token}; domain=localhost; path=/;`;
        sessionStorage.setItem("authToken", token);
        localStorage.setItem("authToken", token);

        setSuccessMessage("Login successful!");
        const redirectUrl = new URL("http://localhost:3000/");
        redirectUrl.searchParams.set("authToken", token);

        setTimeout(() => {
          window.location.href = redirectUrl.toString();
        }, 1000);
      } else {
        console.error("Login failed, unexpected response:", signInResponse);
        setError("loginFailed");
      }
    } catch (err) {
      console.error("Login failed:", err);
      setError(err.message || "loginError");
    } finally {
      setIsLoading(false); // Reset loading state after the operation
      refreshCaptcha();
    }
  };

  const startTimer = (timeCounter) => {
    setTimerCount(timeCounter); // Set timer to 120 seconds (2 minutes)
    const timerInterval = setInterval(() => {
      setTimerCount((prevState) => {
        if (prevState > 0) {
          return prevState - 1;
        }
        clearInterval(timerInterval); // Clear interval when timer reaches 0
        return 0;
      });
    }, 1000); // Set interval to 1 second (1000 milliseconds)
  };

  useEffect(() => {
    if (timerCount === 0) {
      setShowResendOTP(false);
    }
  }, [timerCount]);

  const fetchCaptcha = async () => {
    try {
      const response = await getCaptcha();

      // Set the captcha data
      setCaptchaCode(response?.captchaData);

      // Access the x-captcha-id from the response headers
      setCaptchaId(response?.captchaId); // Use response.captchaId instead of headers.get
    } catch (err) {
      setError(err.message || "loginError");
      console.error("Error fetching captcha in useEffect:", error);
    }
  };

  useEffect(() => {
    fetchCaptcha();
  }, []);

  const refreshCaptcha = () => {
    fetchCaptcha();
  };

  // Handle OTP change
  const handleChange = (otpValue) => {
    setOtp(otpValue);
  };

  const handleResendOTP = async () => {
    console.log("Resend OTP");

    // If CAPTCHA is successful, proceed to sign in
    const userData = {
      email: email, // Assuming 'email' is declared somewhere in the scope
    };

    try {
      // Send OTP request
      const res = await sendOtp(userData); // Assuming sendOtp returns the response with a 'resendOtpTime' property

      if (res && res.resendOtpTime) {
        setShowResendOTP(true);
        startTimer(res.resendOtpTime);
      } else {
        console.error("Failed to receive resendOtpTime in response.");
      }
    } catch (err) {
      setError(err.message || "loginError");
      console.error("Error sending OTP:", error);
    }
  };

  const handleVerificationOtp = async () => {
    console.log("Resend OTP");

    // If CAPTCHA is successful, proceed to sign in
    const otpData = {
      email: email, // Assuming 'email' is declared somewhere in the scope
      otp: otp,
      browser_id: `${fingerprint}`,
    };

    setVerifySpin(true); // Set spinning/loading state before sending request

    try {
      // Send OTP request
      const res = await verifyOtp(otpData); // Assuming verifyOtp returns the response with a 'resendOtpTime' property

      if (res?.msg === "User verified successfully") {
        setVerifySpin(false); // Stop spinner if verification is successful
        setDisplayOtpModal(false); // Close OTP modal
      } else if (res === false || res?.msg !== "User verified successfully") {
        // Handle resend OTP scenario or any failure
        setVerifySpin(false);
        setShowResendOTP(true); // Show resend OTP button or message
      }
    } catch (err) {
      setVerifySpin(false); // Stop spinner in case of error
      console.error("Error sending OTP:", error);
      setError(err.message || "loginError");
    }
  };

  return (
    <div className="flex-container">
      <div className="form-section">
        <div>
          <div>
            <h4 className="title">{"signIn"}</h4>
            <p className="description">{"Sign in to access your account"}</p>
          </div>

          {displayOtpModal ? (
            <div style={{ margin: "50px 0 50px 0" }}>
              <OTPInput
                numInputs={6}
                value={otp} // Bind the value of OTP input to the state
                onChange={handleChange} // Update state on change
                containerStyle={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px", // Add space between the input boxes
                  margin: "50px 0 50px 0",
                }}
                inputStyle={{
                  width: "35px",
                  height: "35px",
                  borderRadius: "5px",
                  textAlign: "center",
                  fontSize: "20px",
                  border: "2px solid #d9d9d9",
                }}
                inputType="tel"
                renderSeparator={<span> </span>}
                renderInput={(props) => <input {...props} />}
              />

              {!verifySpin
                ? showResendOTP && (
                    <span
                      style={{
                        fontWeight: "600",
                        fontSize: "20px",
                        color: "black",
                      }}
                    >
                      Resend OTP in{" "}
                      <span
                        style={{
                          color: "red",
                        }}
                      >
                        {timerCount}s
                      </span>
                    </span>
                  )
                : ""}
              {!verifySpin
                ? showResendOTP && (
                    <button
                      style={{
                        borderColor: "#1890ff",
                        borderRadius: "4px",
                        display: "flex", // This ensures text and image are aligned horizontally
                        textAlign: "center", // Vertically centers the text and image
                        margin: "130px 0 0 0",
                      }}
                      onClick={handleVerificationOtp}
                    >
                      Submit
                    </button>
                  )
                : ""}

              {!verifySpin ? (
                timerCount === 0 && !showResendOTP ? (
                  <button
                    type="default"
                    style={{
                      borderColor: "#1890ff",
                      borderRadius: "4px",
                      width: "auto",
                      display: "flex", // This ensures text and image are aligned horizontally
                      alignItems: "center", // Vertically centers the text and image
                      padding: "6px 12px", // Optional padding for spacing
                    }}
                    onClick={handleResendOTP}
                  >
                    <img
                      onClick={refreshCaptcha} // Function to handle the refresh logic
                      src={require("../../assets/refresh.svg").default}
                      alt="refresh"
                      style={{
                        marginRight: "8px", // Optional: Adds space between the text and the image
                        width: "25px", // Optional: Sets the image size, you can adjust this as needed
                        height: "25px", // Optional: Sets the image size, you can adjust this as needed
                      }}
                    />
                    Resend OTP
                  </button>
                ) : (
                  ""
                )
              ) : (
                ""
              )}
            </div>
          ) : (
            <div className="form-container">
              <form className="login-form" onSubmit={handleSubmit}>
                <div className="input-group">
                  <input
                    type="text"
                    id="email"
                    placeholder=" "
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoComplete="email"
                  />
                  <label htmlFor="email">{"email"}</label>
                </div>

                <div className="input-group">
                  <input
                    type={isPasswordVisible ? "text" : "password"} // Toggle input type
                    id="password"
                    placeholder=" "
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    autoComplete="current-password"
                  />
                  <label htmlFor="password">{"password"}</label>
                  <span
                    className="eye-icon"
                    onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                  >
                    {isPasswordVisible ? (
                      <img
                        src={require("../../assets/eye.svg").default}
                        alt="Show password"
                      />
                    ) : (
                      <img
                        src={require("../../assets/hidden.svg").default}
                        alt="Hide password"
                      />
                    )}
                  </span>
                </div>
                <div className="forgot-password">
                  <a href="/forgot-password">{"Forgot Password ?"}</a>
                </div>

                <div className="flex-container-captcha">
                  {/* CAPTCHA */}
                  <div className="input-group">
                    <input
                      type="text"
                      id="captcha"
                      placeholder=" "
                      value={captcha}
                      onChange={(e) => setCaptcha(e.target.value)}
                      required
                    />
                    <label htmlFor="captcha">Enter CAPTCHA</label>
                  </div>

                  <div className="input-group">
                    <input
                      type="text"
                      id="captchaCode"
                      placeholder=" "
                      value="" // Keep the value empty or bind it to the input state
                      onChange={(e) => setCaptchaCode(e.target.value)}
                      required
                      style={{
                        paddingLeft: "40px", // Space for the icon
                        backgroundImage: `url(data:image/svg+xml;base64,${btoa(
                          captchaCode
                        )})`, // Assuming captchaCode is an SVG string
                        backgroundSize: "150px", // Adjust the icon size
                        backgroundPosition: "10px center", // Position it inside the input
                        backgroundRepeat: "no-repeat",
                      }}
                      disabled
                    />

                    <span className="eye-icon">
                      <img
                        onClick={refreshCaptcha} // Function to handle the refresh logic
                        src={require("../../assets/refresh.svg").default}
                        alt="refresh"
                      />
                    </span>
                  </div>
                </div>

                {/* <div className="remember-me">
                <input
                  type="checkbox"
                  id="vehicle1"
                  name="vehicle1"
                  value="Bike"
                />
                <p>Remember me</p>
              </div> */}

                <button type="submit" disabled={isLoading}>
                  {isLoading ? "loggingIn" : "login"}
                </button>

                <ToastMessage
                  message={error || successMessage}
                  type={error ? "error" : "success"}
                />
              </form>
            </div>
          )}
          {/* <div
            className="footer"
            style={{
              margin: "85px 0 0 420px",
            }}
          >
            <div className="footer-links">
              <a
                href="/terms"
                style={{
                  display: "flex", // Aligns items in a row (horizontally)
                  alignItems: "center", // Vertically aligns text and image
                  textDecoration: "none", // Removes default underline
                  fontSize: "16px", // Set a consistent font size for the text
                }}
              >
                <img
                  src={require("../../assets/i-icon.svg").default}
                  alt="refresh"
                  style={{
                    width: "20px", // Set a fixed width for the image
                    height: "20px", // Set a fixed height for the image
                    marginRight: "8px", // Space between image and text
                  }}
                />
                About Us
              </a>
              <a
                href="/privacy"
                style={{
                  display: "flex", // Aligns items in a row (horizontally)
                  alignItems: "center", // Vertically aligns text and image
                  textDecoration: "none", // Removes default underline
                  fontSize: "16px", // Set a consistent font size for the text
                }}
              >
                <img
                  src={require("../../assets/phone.svg").default}
                  alt="refresh"
                  style={{
                    width: "20px", // Set a fixed width for the image
                    height: "20px", // Set a fixed height for the image
                    marginRight: "8px", // Space between image and text
                  }}
                />
                Contact Us
              </a>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};
export default Login;
